<div class="page-container">
  <div class="card p-3 m-3">
  <div class="row px-3 mb-2">
    <div class="statistics mb-2 d-flex align-items-end gap-3">
      <a href="/statistics" target="_self" class="statistics-link d-flex align-items-center gap-2">
        <h2 class="mb-0">
          <b style="color: black;">Statistiche Consegnati</b>
        </h2>
        <i class="fas fa-reply return-icon"></i>
      </a>
    </div>


    <!-- FILTRI IN RIGA -->
    <form (ngSubmit)="fetchStatistics()">

      <div class="d-flex flex-wrap gap-3 mb-3">
        <!-- <div class="filter-item" style="min-width: 150px;">
          <label class="form-label">Codice Bolla</label>
          <input type="text" class="form-control" [(ngModel)]="waybillCode" name="waybillCode">
        </div> -->

        <div class="filter-item" style="min-width: 200px;" *ngIf="filteredClients.length > 1">
          <label class="form-label">Clienti</label>
          <div class="multi-select-wrapper">
            <ng-multiselect-dropdown
              *ngIf="filteredClients.length > 0 && dropdownSettingsClient"
              name="clients"
              [placeholder]="'Seleziona clienti'"
              [settings]="dropdownSettingsClient"
              [data]="filteredClients"
              [(ngModel)]="selectedClients"
              [ngModelOptions]="{standalone: true}"
              (onSelect)="onClientsChange()"
              (onDeSelect)="onClientsChange()"
              (onSelectAll)="selectAllClients()"
              (onDeSelectAll)="deselectAllClients()"
            >
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="filter-item" style="min-width: 200px;" *ngIf="filteredBrands.length > 1">
          <label class="form-label">Marchi</label>
          <div class="multi-select-wrapper">
            <ng-multiselect-dropdown *ngIf="filteredBrands.length > 0 && dropdownSettingsBrand"
              name="brands"
              [placeholder]="'Seleziona marchi'"
              [settings]="dropdownSettingsBrand"
              [data]="filteredBrands"
              [(ngModel)]="selectedBrands"
              [ngModelOptions]="{standalone: true}"
              >
            </ng-multiselect-dropdown>
          </div>
        </div>

        <div class="filter-item" style="min-width: 150px;">
          <label class="form-label">Transit Point</label>
          <select class="form-select" [(ngModel)]="warehouseCode" name="warehouseCode">
            <option value="">Tutti i TP</option>
            <option *ngFor="let warehouse of filteredWarehouses" [value]="warehouse.warehouseCode">
              {{ warehouse.warehouseName }}
            </option>
          </select>
        </div>

        <div class="filter-item" style="min-width: 150px;">
          <label class="form-label">Dealer</label>
          <select class="form-select" [(ngModel)]="waybillDealerCode" name="waybillDealerCode">
            <option value="">Tutti i dealer</option>
            <option *ngFor="let dealer of filteredDealers" [value]="dealer.dealerCode">
              {{ dealer.dealerName }} - {{ dealer.dealerOperatingAddressCity }}
            </option>
          </select>
        </div>

        <div class="filter-item" style="min-width: 150px;">
          <label class="form-label">Regioni</label>
          <select class="form-select" [(ngModel)]="regionCode" name="regionCode">
            <option value="">Tutte le regioni</option>
            <option *ngFor="let region of filteredRegions" [value]="region.regionCode">
              {{ region.regionName }}
            </option>
          </select>
        </div>        
        
        <div class="mb-2 d-flex">
          <div class="filter-item" style="min-width: 180px;">
            <label style="padding-left:30px;" class="form-label">Data Inizio</label>
            <div class="d-flex align-items-center">
              <button class="date-nav-btn" type="button" (click)="decrementStartDate(); decrementEndDate()" title="Giorno precedente">
                <i class="fa fa-chevron-left"></i>
              </button>
              <input type="date" class="form-control" [(ngModel)]="waybillDateStart" name="waybillDateStart">
              <!--<button class="date-nav-btn" type="button" (click)="incrementStartDate()" title="Giorno successivo">
                <i class="fa fa-chevron-right"></i>
              </button>-->
            </div>
          </div>

          <div class="filter-item" style="min-width: 180px;">
            <label class="form-label">Data Fine</label>
            <div class="d-flex align-items-center">
              <!--<button class="date-nav-btn" type="button" (click)="decrementEndDate()" title="Giorno precedente">
                <i class="fa fa-chevron-left"></i>
              </button>-->
              <input type="date" class="form-control" [(ngModel)]="waybillDateEnd" name="waybillDateEnd">
              <button class="date-nav-btn" type="button" (click)="incrementEndDate(); incrementStartDate()" title="Giorno successivo">
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- BOTTONE FILTRA + RESET IN RIGA A DESTRA -->
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-primary" type="submit">Applica Filtri</button>
        <button class="btn btn-light" type="button" (click)="resetFilters()">Reset</button>
      </div>

    </form>
  </div>
</div>


  <!-- LOADING -->
  <div *ngIf="loading" class="text-center mt-4">
    <div class="spinner-border text-primary" role="status"></div>
    <p>Caricamento dati...</p>
  </div>

  <!-- ERRORE -->
  <div *ngIf="error" class="alert alert-danger text-center">
    {{ error }}
  </div>

  <!-- WARNING -->
  <div *ngIf="warning" class="alert alert-warning p-3 m-3">
    <div class="d-flex align-items-center">
      <i class="fas fa-exclamation-triangle me-2"></i>
      <span>{{ warning }}</span>
    </div>
  </div>

  <!-- RISULTATI -->
  <div *ngIf="stats && !loading" class="row p-3 m-3">

    

    <!-- Card: Totale Colli -->
    <div class="col-md-3 col-sm-6 mb-2">
      <div class="card shadow-sm h-100 border bg-white p-3">
        <div class="card-body p-2">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="fs-4 text-dark">Totale colli consegnati</div>
            <div class="display-5 fw-bold text-dark mb-0">{{ stats.totalDelivered }}</div>
          </div>

          <span class="text-dark"> Di cui:</span>

          <div class="bg-light border rounded px-3 py-2 mb-2 d-flex justify-content-between align-items-center">
            <span class="text-dark"> DMDC consegnati </span>
            <span class="fw-bold">{{ stats.dmdc }}</span>
          </div>

          <span class="text-dark"> Geofencing sul totale consegnati: </span>

          <!-- Mini-info: DMDC -->
          <div class="bg-light border rounded px-3 py-2 mb-2 d-flex justify-content-between align-items-center">
            <span class="text-dark"> Coordinate corrette </span>
            <span class="fw-bold">{{ stats.inRange }}</span>
          </div>

          <!-- Mini-info: BIG ORDERS -->
          <div class="bg-light border rounded px-3 py-2 mb-2 d-flex justify-content-between align-items-center">
            <span class="text-dark"> Coordinate errate </span>
            <span class="fw-bold">{{ stats.notInRange }}</span>
          </div>

          

          <!-- Mini-info: MANCANTI
          <div class="bg-light border rounded px-3 py-2 mb-2 d-flex justify-content-between align-items-center">
            <span class="text-dark"> Mancanti e/o lasciati a terra</span>
            <span class="fw-bold">{{ stats.parcelsMancanti }}</span>
          </div>

          <div class="bg-light border rounded px-3 py-2 mb-2 d-flex justify-content-between align-items-center">
            <span class="text-dark"> Big Orders inviati a PTV</span>
            <span class="fw-bold">{{ stats.parcelsBigOrdersPTV }}</span>
          </div>

          
          <div class="bg-white border border-bright-green rounded px-3 py-2 mt-3">
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-bright-green fw-semibold fs-5">Totale da confrontare con PTV</span>
              <span class="fw-bold text-bright-green fs-5">
                {{
                  stats.parcelsTotali -
                  stats.parcelsBigOrders -
                  stats.parcelsMancanti +
                  stats.parcelsBigOrdersPTV
                }}
              </span>
            </div>

            <div *ngIf="dateBefore26" class="mt-2">
              <small class="fst-italic text-muted d-block">
                <i class="fas fa-exclamation-triangle me-1" style="color: orange;"></i>
                Da sommare i colli mancanti e/o lasciati a terra
              </small>
            </div>
          </div> -->

        </div>
      </div>
    </div>

    <!-- A*B -->
    <div class="col-md-3 col-sm-6 mb-2">
      <div class="card shadow-sm h-100 border bg-white p-3">
        <div class="card-body p-2">
          <div class="d-flex justify-content-between align-items-center mb-2 flex-nowrap gap-2">
            <div class="fs-4 text-dark">Percentuale consegnati <br> (<span class="text-primary fw-bold">A*B</span>)
              <button class="btn btn-sm btn-outline-primary ms-2" data-bs-toggle="modal" data-bs-target="#dettaglioConsegneModal">
                <span>Night/Day</span>
              </button>
            </div>
            <div class="display-6 fw-bold text-primary mb-0 text-nowrap">
              {{
                (
                  (
                    (stats?.totalDelivered || 0)
                    - (stats?.aperCDelivered || 0)
                    - (stats?.dmdc || 0)
                  ) > 0 &&
                  (
                    (statsAffidati?.parcelsTotali || 0)
                    - (statsAffidati?.parcelsAperC || 0)
                    - (statsAffidati?.parcelsDMDC || 0)
                    - (statsAffidati?.parcelsBigOrders || 0)
                  ) > 0
                )
                  ? (
                      (
                        (stats?.totalDelivered || 0)
                        - (stats?.aperCDelivered || 0)
                        - (stats?.dmdc || 0)
                      )
                      /
                      (
                        (statsAffidati?.parcelsTotali || 0)
                        - (statsAffidati?.parcelsAperC || 0)
                        - (statsAffidati?.parcelsDMDC || 0)
                        - (statsAffidati?.parcelsBigOrders || 0)
                      )
                    * 100
                  ).toFixed(2)
                  : 0
              }} %
            </div>
          </div>

          <hr class="my-2">

          <div class="small text-muted">
            <div>
              <strong>Numeratore:</strong><br>
              (colli consegnati - colli consegnati A*C - colli consegnati dmdc)<br>
              = ({{ stats?.totalDelivered || 0 }} - {{ stats?.aperCDelivered || 0 }} - {{ stats?.dmdc || 0 }})<br>
              = <strong>
                {{
                  (stats?.totalDelivered || 0)
                  - (stats?.aperCDelivered || 0)
                  - (stats?.dmdc || 0)
                }}
              </strong>
            </div>
            <div class="mt-1">
              <strong>Denominatore:</strong><br>
              (colli totali - colli A*C - colli DMDC - colli Big Orders)<br>
              = ({{ statsAffidati?.parcelsTotali || 0 }} - {{ statsAffidati?.parcelsAperC || 0 }} - {{ statsAffidati?.parcelsDMDC || 0 }} - {{ statsAffidati?.parcelsBigOrders || 0 }})<br>
              = <strong>
                {{
                  (statsAffidati?.parcelsTotali || 0)
                  - (statsAffidati?.parcelsAperC || 0)
                  - (statsAffidati?.parcelsDMDC || 0)
                  - (statsAffidati?.parcelsBigOrders || 0)
                }}
              </strong>
            </div>
          </div>

        </div>
      </div>
    </div>



  <!-- A*C -->
    <div class="col-md-3 col-sm-6 mb-2">
      <div class="card shadow-sm h-100 border bg-white p-3">
        <div class="card-body p-2">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="fs-4 text-dark">Percentuale consegnati <br> (<span class="text-primary fw-bold">A*C</span>)</div>
            <div class="display-6 fw-bold text-primary mb-0 text-nowrap">
              {{
                (
                  (stats?.aperCDelivered || 0) > 0 &&
                  (
                    (statsAffidati?.parcelsAperC || 0)
                  ) > 0
                )
                  ?
                  (
                    (
                      (stats?.aperCDelivered || 0) /
                      (
                        (statsAffidati?.parcelsAperC || 0)
                      )
                    ) * 100
                  ).toFixed(2)
                  : 0
              }} %
            </div>
          </div>

          <hr class="my-2">

          <div class="small text-muted">
            <div><strong>Numeratore:</strong> (colli consegnati A*C) = ( {{ stats?.aperCDelivered || 0 }}) = <strong>{{ (stats?.aperCDelivered || 0) }}</strong></div>
            <div>
              <strong>Denominatore:</strong> (colli totali A*C)<br>
              = ({{ statsAffidati?.parcelsAperC || 0 }})<br>
              = <strong>
                {{
                  (statsAffidati?.parcelsAperC || 0)
                }}
              </strong>
            </div>
          </div>

        </div>
      </div>
    </div>


    <!-- A*D -->
    <div class="col-md-3 col-sm-6 mb-2">
      <div class="card shadow-sm h-100 border bg-white p-3">
        <div class="card-body p-2">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="fs-4 text-dark">Percentuale consegnati <br> (<span class="text-primary fw-bold">A*D</span>)</div>
            <div class="display-6 fw-bold text-primary mb-0 text-nowrap">
              {{
                (
                  (stats?.aperDDelivered || 0) > 0 &&
                  (
                    (statsAffidati?.parcelsAperD || 0)
                  ) > 0
                )
                  ?
                  (
                    (
                      (stats?.aperDDelivered || 0) /
                      (
                        (statsAffidati?.parcelsAperD || 0)
                      )
                    ) * 100
                  ).toFixed(2)
                  : 0
              }} %
            </div>
          </div>

          <hr class="my-2">

          <div class="small text-muted">
            <div><strong>Numeratore:</strong> (colli consegnati A*D) = ( {{ stats?.aperDDelivered || 0 }}) = <strong>{{ (stats?.aperDDelivered || 0) }}</strong></div>
            <div>
              <strong>Denominatore:</strong> (colli totali A*D)<br>
              = ({{ statsAffidati?.parcelsAperD || 0 }})<br>
              = <strong>
                {{
                  (statsAffidati?.parcelsAperD || 0)
                }}
              </strong>
            </div>
          </div>

        </div>
      </div>
    </div>



    
    <div class="col-md-3 col-sm-6 mb-2">
      <div class="card shadow-sm h-100 border bg-white p-3">
        <div class="card-body p-2">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="fs-4 text-dark">Percentuale consegnati <br> (<span class="text-primary fw-bold">DMDC</span>)</div>
            <div class="display-6 fw-bold text-primary mb-0 text-nowrap">
              {{
                (
                  (stats?.dmdc || 0) > 0 &&
                  (
                    (statsAffidati?.parcelsDMDC || 0)
                  ) > 0
                )
                  ?
                  (
                    (
                      (stats?.dmdc || 0) /
                      (
                        (statsAffidati?.parcelsDMDC || 0)
                      )
                    ) * 100
                  ).toFixed(2)
                  : 0
              }} %
            </div>
          </div>

          <hr class="my-2">

          <div class="small text-muted">
            <div><strong>Numeratore:</strong> (colli consegnati DMDC) = ( {{ stats?.dmdc || 0 }}) = <strong>{{ (stats?.dmdc || 0) }}</strong></div>
            <div>
              <strong>Denominatore:</strong> (colli totali DMDC)<br>
              = ({{ statsAffidati?.parcelsDMDC || 0 }})<br>
              = <strong>
                {{
                  (statsAffidati?.parcelsDMDC || 0)
                }}
              </strong>
            </div>
          </div>

        </div>
      </div>
    </div>


  <!-- A*B + A*C -->
    <div class="col-md-3 col-sm-6 mb-2">
      <div class="card shadow-sm h-100 border bg-white p-3">
        <div class="card-body p-2">
        <div class="d-flex justify-content-between align-items-center mb-2 flex-nowrap gap-2">

          <div class="fs-4 text-dark">Percentuale consegnati <br> (<span class="text-primary fw-bold">A*B + A*C</span>)</div>
          <div class="display-6 fw-bold text-primary mb-0 text-nowrap">
            {{
              (
                ((stats?.totalDelivered || 0) - (stats?.dmdc || 0)) > 0 &&
                (
                  (statsAffidati?.parcelsTotali || 0)
                  - (statsAffidati?.parcelsDMDC || 0)
                  - (statsAffidati?.parcelsBigOrders || 0)
                ) > 0
              )
                ?
                (
                  (
                    ((stats?.totalDelivered || 0) - (stats?.dmdc || 0)) /
                    (
                      (statsAffidati?.parcelsTotali || 0)
                      - (statsAffidati?.parcelsDMDC || 0)
                      - (statsAffidati?.parcelsBigOrders || 0)
                    )
                  ) * 100
                ).toFixed(2)
                : 0
            }} %
          </div>
        </div>

        <hr class="my-2">

        <div class="small text-muted">
          <div><strong>Numeratore:</strong> (colli consegnati - colli consegnati dmdc) = ({{ stats?.totalDelivered || 0 }} - {{ stats?.dmdc || 0 }}) = <strong>{{ (stats?.totalDelivered || 0) - (stats?.dmdc || 0) }}</strong></div>
          <div>
            <strong>Denominatore:</strong> (colli totali - colli DMDC - colli Big Orders)<br>
            = ({{ statsAffidati?.parcelsTotali || 0 }} - {{ statsAffidati?.parcelsDMDC || 0 }} - {{ statsAffidati?.parcelsBigOrders || 0 }})<br>
            = <strong>
              {{
                (statsAffidati?.parcelsTotali || 0)
                - (statsAffidati?.parcelsDMDC || 0)
                - (statsAffidati?.parcelsBigOrders || 0)
              }}
            </strong>
          </div>
        </div>

        </div>
      </div>
    </div>


    <div class="col-md-3 col-sm-6 mb-2">
      <div class="card shadow-sm h-100 border bg-white p-3">
        <div class="card-body p-2">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div class="fs-4 text-dark">Percentuale consegnati <br> (<span class="text-primary fw-bold">A*B + A*C + A*D + DMDC</span>)</div>
      <div class="display-6 fw-bold text-primary mb-0 text-nowrap">
        {{
          (
            ((stats?.totalDelivered || 0)) > 0 &&
            (
              (statsAffidati?.parcelsTotali || 0)
              - (statsAffidati?.parcelsBigOrders || 0)
            ) > 0
          )
            ?
            (
              (
                ((stats?.totalDelivered || 0)) /
                (
                  (statsAffidati?.parcelsTotali || 0)
                  - (statsAffidati?.parcelsBigOrders || 0)
                )
              ) * 100
            ).toFixed(2)
            : 0
        }} %
      </div>
    </div>

    <hr class="my-2">

    <div class="small text-muted">
      <div><strong>Numeratore:</strong> (colli consegnati) = ({{ stats?.totalDelivered || 0 }}) = <strong>{{ (stats?.totalDelivered || 0) }}</strong></div>
      <div>
        <strong>Denominatore:</strong> (colli totali - colli Big Orders)<br>
        = ({{ statsAffidati?.parcelsTotali || 0 }} - {{ statsAffidati?.parcelsBigOrders || 0 }})<br>
        = <strong>
          {{
            (statsAffidati?.parcelsTotali || 0)
            - (statsAffidati?.parcelsBigOrders || 0)
          }}
        </strong>
      </div>
    </div>

        </div>
      </div>
    </div>

    


  </div>

  <!-- Modal -->
  <div class="modal " id="dettaglioConsegneModal" tabindex="-1" aria-labelledby="dettaglioConsegneLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="dettaglioConsegneLabel">Dettaglio consegne <b class="text-primary">Night/Day</b></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi"></button>
        </div>
        <div class="modal-body">
          <div class="row g-3">

            <!-- NIGHT DELIVERY -->
            <div class="col-md-6">
              <div class="card shadow-sm h-100 border bg-white p-3">
                <div class="card-body p-2">
                  <div class="d-flex justify-content-between align-items-center mb-2 flex-nowrap gap-2">
                    <div class="fs-5 text-dark">Percentuale consegnati <b class="text-primary">Night</b></div>
                    <div class="fs-4 fw-bold text-primary mb-0 text-nowrap">
                      {{ getPercentage(stats?.nightDelivery, statsAffidati?.parcelsNight) }} %
                    </div>
                  </div>


                  <hr class="my-2">

                  <div class="small text-muted">
                    <div>
                      <strong>Numeratore:</strong><br>
                      colli consegnati Night = <strong>{{ stats?.nightDelivery || 0 }}</strong>
                    </div>
                    <div class="mt-1">
                      <strong>Denominatore:</strong><br>
                      colli affidati Night = <strong>{{ statsAffidati?.parcelsNight || 0 }}</strong>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- DAY DELIVERY -->
            <div class="col-md-6">
              <div class="card shadow-sm h-100 border bg-white p-3">
                <div class="card-body p-2">
                  <div class="d-flex justify-content-between align-items-center mb-2 flex-nowrap gap-2">
                    <div class="fs-5 text-dark">Percentuale consegnati <b class="text-primary">Day</b></div>
                    <div class="fs-4 fw-bold text-primary mb-0 text-nowrap">
                       {{ getPercentage(stats?.dayDelivery, statsAffidati?.parcelsDay) }} %
                    </div>
                  </div>

                  <hr class="my-2">

                  <div class="small text-muted">
                    <div>
                      <strong>Numeratore:</strong><br>
                      colli consegnati Day = <strong>{{ stats?.dayDelivery || 0 }}</strong>
                    </div>
                    <div class="mt-1">
                      <strong>Denominatore:</strong><br>
                      colli affidati Day = <strong>{{ statsAffidati?.parcelsDay || 0 }}</strong>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-light" data-bs-dismiss="modal">Chiudi</button>
        </div>
      </div>
    </div>
  </div>



</div>